// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: white;
}

.reports-container {
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding:2%;
    padding-left:4%; 
    padding-right: 4%; 

    background-color: white;
  
}

.direct-button {
    margin: 10px 15px;
    padding: 1px;
    color: rgb(255, 255, 255);
    background-color: #286090;
    border-radius: 5px;
    width: max-content;
    font-size: 15px;
    text-align: left;
} 

.report-deligation-container{
    width:100%;
   
 }

 .report-deligation-sub-container{
    width:100%;
    border:2px solid  #286090;
    border-radius:10px;
    margin:2% 0%;
 }
 .container1{
   
    margin: 0px;
   padding-left: 2%;
   padding-right: 2%;
    border-radius: 10px;
    background-color: #fff;
 }

 /* .pending-deligations{
    text-align:center;
 } */

 .employee-detail-container{
    width:100%;
    border:2px solid  #286090;
    border-radius:10PX;
 }
 .text
{
    text-align: left;
    font-weight: bold;
    padding-left: 1%;
}
.select-text
{
    color:white;
    background-color: #286090;
    border-radius: 5px 5px 0 0;
    text-align: left;
    padding-left:1%;
}

.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10px;
  }
  /* .searchFilter{
    display: grid;
    padding-bottom: 10px;
  }
  
  .center-content {
    margin: auto !important;
    text-align: center;
  } */
  
 
.employee-name-text{
  margin-left:1%;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px; /* Adjust as needed */
}



  
`, "",{"version":3,"sources":["webpack://./src/app/report/directdelegationadmin/directdelegationadmin.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,iBAAiB;;IAEjB,uBAAuB;;AAE3B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;;CAEb;;CAEA;IACG,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;CACf;CACA;;IAEG,WAAW;GACZ,gBAAgB;GAChB,iBAAiB;IAChB,mBAAmB;IACnB,sBAAsB;CACzB;;CAEA;;IAEG;;CAEH;IACG,UAAU;IACV,yBAAyB;IACzB,kBAAkB;CACrB;CACA;;IAEG,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;EACA;;;;;;;;KAQG;;;AAGL;EACE,cAAc;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;AAC3C","sourcesContent":["body {\n    background-color: white;\n}\n\n.reports-container {\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding:2%;\n    padding-left:4%; \n    padding-right: 4%; \n\n    background-color: white;\n  \n}\n\n.direct-button {\n    margin: 10px 15px;\n    padding: 1px;\n    color: rgb(255, 255, 255);\n    background-color: #286090;\n    border-radius: 5px;\n    width: max-content;\n    font-size: 15px;\n    text-align: left;\n} \n\n.report-deligation-container{\n    width:100%;\n   \n }\n\n .report-deligation-sub-container{\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10px;\n    margin:2% 0%;\n }\n .container1{\n   \n    margin: 0px;\n   padding-left: 2%;\n   padding-right: 2%;\n    border-radius: 10px;\n    background-color: #fff;\n }\n\n /* .pending-deligations{\n    text-align:center;\n } */\n\n .employee-detail-container{\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10PX;\n }\n .text\n{\n    text-align: left;\n    font-weight: bold;\n    padding-left: 1%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    border-radius: 5px 5px 0 0;\n    text-align: left;\n    padding-left:1%;\n}\n\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 10px;\n  }\n  /* .searchFilter{\n    display: grid;\n    padding-bottom: 10px;\n  }\n  \n  .center-content {\n    margin: auto !important;\n    text-align: center;\n  } */\n  \n \n.employee-name-text{\n  margin-left:1%;\n}\n\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px; /* Adjust as needed */\n}\n\n\n\n  \n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
